import React, { Fragment, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { Header } from "gce-cxinteracts-ui-components-library";
import TalkToUs from "../../../Components/TalkToUs/TalkToUs";
import Faq, { IFaq, Faqdetails } from "../../../Models/ReduxModels/FaqModel";
import { useStyles } from "./styles";
import { ConstantMapping } from "../../../Configurations/ConstantsMapping";
import ApplicationFlag, {
  IApplication
} from "../../../Models/ReduxModels/ApplicationFlag";
import { Typography, Button } from "@material-ui/core";
import { getClientName, getImageDetails } from "../../../Utils/GeneralUtils";
import { ImagesMapping } from "Configurations/ImagesMapping";
interface IProps {
  faqs: IFaq;
  applicatinFlags: IApplication;
}

const Help: React.FC<IProps> = props => {
  const { faqs, applicatinFlags } = props;
  const clientName = getClientName();
  let question = faqs?.configurationDataList || [];
  let classes = useStyles();
  const history = useHistory();
  const [showTalkToUs, setShowTalkToUs] = useState(false);
  const [questions, setQuestions] = useState<Faqdetails[]>([...question]);
  const root = document.getElementById("root");
  let onLoadParams = {};
  const setLimitedQuestions = () => {
    if (applicatinFlags?.isShowFooter && question.length > 5) {
      let questionDetails = question.slice(0, 5);
      setQuestions(questionDetails);
    } else {
      setQuestions(question);
    }
  };

  useEffect(() => {
    resetScroll();
  }, []);
  useEffect(() => {
    setLimitedQuestions();
  }, [applicatinFlags]);
  const resetScroll = () => {
    if (root) {
      root.scrollTop = 0;
    }
  };
  const showFaq = (id: string, title: string) => {
    onLoadParams = {
      page_name: `${ConstantMapping[clientName].TEALIUM_PAGE_PREFIX}${ConstantMapping[clientName].TEALIUM_PAGE_FAQ}${title}`
    };
    history.push(`/faq/${id}`, { onLoadParams });
  };

  const seeMoreQuestions = () => {
    setQuestions(question);
    setShowTalkToUs(true);
    new ApplicationFlag({
      id: "",
      isShowFooter: false
    }).$save();
  };

  const goToBackPage = () => {
    if (!showTalkToUs && applicatinFlags?.isShowFooter) {
      window.history.back();
    } else {
      setLimitedQuestions();
      setShowTalkToUs(false);
      new ApplicationFlag({
        id: "",
        isShowFooter: true
      }).$save();
    }
  };

  const redirectToHome = () => {
    history.push("/home");
    new ApplicationFlag({
      id: "",
      isShowFooter: true
    }).$save();
  };
  return (
    <Fragment>
      <div className={classes.mainContainer}>
        <Header
          headerText=""
          isHeaderInverted={false}
          svgProps={ConstantMapping[clientName].SVG.headerSvgStyle}
          clientLogoPrimary={getImageDetails(
            ImagesMapping[clientName].clientLogoPrimary,
            ConstantMapping[clientName].CLIENT_ICON_TEXT
          )}
          clientLogoSecondary={getImageDetails(
            ImagesMapping[clientName].clientLogoSecondary,
            ConstantMapping[clientName].CLIENT_ICON_TEXT
          )}
          onSvgSelection={goToBackPage}
          onLogoSelection={redirectToHome}
          isScrollHeader={false}
        />
        <div className={classes.contentWrapper}>
          <div
            className={`${classes.content} ${
              applicatinFlags?.isShowFooter
                ? classes.showFooter
                : classes.hideFooter
            }`}
          >
            {/* Heading FAQ */}
            <div className={classes.headingWrapper}>
              <Typography variant="h4" className={classes.heading} gutterBottom>
                {`${faqs?.name.toUpperCase()}s`}
              </Typography>
            </div>
            {/* Question Set */}
            <div className={classes.questionWrapper}>
              {questions.map(quest => {
                return (
                  <button
                    onClick={() => showFaq(quest.id, quest.name)}
                    aria-label={quest.name}
                    tabIndex={0}
                    className={classes.buttonDefault}
                  >
                    <div key={quest.id} className={classes.question}>
                      <Typography
                        variant="h6"
                        className={classes.questionTitle}
                      >
                        {quest.name}
                      </Typography>
                    </div>
                  </button>
                );
              })}
              {applicatinFlags?.isShowFooter && (
                <button
                  onClick={seeMoreQuestions}
                  aria-label="See more"
                  tabIndex={0}
                  className={classes.buttonDefault}
                >
                  <div className={classes.seeMoreWrapper}>
                    <Typography variant="h4" className={classes.seeMore}>
                      {ConstantMapping[clientName].SEE_MORE_TEXT}
                    </Typography>
                    <img
                      alt=""
                      className={classes.arrowLeft}
                      src={ImagesMapping[clientName].arrowLeftIcon}
                    />
                  </div>
                </button>
              )}
            </div>
            {/* Talk TO US */}
            <TalkToUs
              showOnFaq={!applicatinFlags?.isShowFooter}
              tealiumPageName={`${ConstantMapping[clientName].TEALIUM_PAGE_PREFIX}${ConstantMapping[clientName].TEALIUM_PAGE_HELP}`}
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state: any) => {
  const faqs = Faq.getInsatnce("", state)?.props;
  let applicatinFlags = ApplicationFlag.getInsatnce("", state).props;
  return {
    faqs,
    applicatinFlags
  };
};

export default connect(mapStateToProps)(Help);
